//
//
//
//
//
//

import { filterObjectList } from '@/utils/tools'

export default {
  name: 'DictLabel',
  props: {
    dictKey: '',
    dictLabel: '',
    url: '',
    value: null,
    isMultiple: false // 是否具有多个值，如果为true，value属性必须数个数组
  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      text: ''
    }
  },
  watch: {
    url (val) {
      if (val !== '') {
        this.getData()
      }
    },
    value (val) {
      if (val !== '') {
        this.getData()
      }
    }
  },
  methods: {
    getData () {
      if (this.url === '' || this.value === '') {
        return
      }
      this.info = {}
      const httpUrl = this.baseUrl + '/wechat/api/getDictInfo'
      const params = {
        url: this.url
      }
      const _this = this
      this.$http.post(httpUrl, params).then(({ data }) => {
        if (data.status === true) {
          let str = ''
          if (_this.isMultiple) {
            let lables = []
            if (Array.isArray(_this.value)) {
              _this.value.forEach((item) => {
                const filterText = filterObjectList(data.data, _this.dictKey, _this.dictLabel, item)
                if (filterText !== '' && filterText !== undefined && filterText !== null) {
                  lables.push(filterText)
                }
              })
            }
            str = lables.join(',')
          } else {
            str = filterObjectList(data.data, _this.dictKey, _this.dictLabel, _this.value)
          }
          _this.text = str
        }
      })
    }
  },
  created () {
    this.getData()
  }
}



// WEBPACK FOOTER //
// ./src/components/dict/DictLabel.vue